import React from "react";
import "./Banner.css";
import { FaPhoneAlt, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import BANNER from "../images/Banner.png";

export default function Banner() {
  return (
    <>
      <section
        className="hero-bg"
        style={{ backgroundImage: `url(${BANNER})` }}
      >
        <div className="overlay"></div>

        {/* CENTER CONTENT */}
        <div className="hero-center-content">

          {/* ✨ CINEMATIC RACING TITLE */}
          <h1 className="cinematic-title">
            SRI RAJALAKSHMI TOURS TRAVELS
            <span className="shine"></span>
          </h1>

          <p className="hero-slogan">
            Your Perfect Partner for Safe & Comfortable Travel in Aruppukottai
          </p>

          {/* CONTACT BAR */}
          <div className="contact-bar-banner">

            <a href="tel:+919095223243" className="banner-contact-box">
              <FaPhoneAlt className="banner-contact-icon" />
              <span>Call Now</span>
            </a>

            <a href="https://wa.me/919095223243" className="banner-contact-box">
              <FaWhatsapp className="banner-contact-icon" />
              <span>WhatsApp</span>
            </a>

            <a href="mailto:srirajalakshmitravels@gmail.com" className="banner-contact-box">
              <FaEnvelope className="banner-contact-icon" />
              <span>Email</span>
            </a>

          </div>
        </div>

        {/* Moving Road Animation */}
        <div className="moving-road"></div>
      </section>
    </>
  );
}
